<template>
  <q-page
    :style-fn="tweakHeight"
    :style="`height: ${offset}`"
  >
    <div class="q-py-xl flex flex-center panel-title">
      <div class="q-pa-md text-center">
        <q-spinner v-if="loading" size="lg"/>
        <div v-else-if="!accessToken" class="no-login" style="width: 420px">
          <p class="auth-menu-title">{{ t('title') }}</p>
          <q-form
            @submit="credentialsLogin"
            method="post"
          >
            <q-input
              dense
              name="username"
              v-model="credentials.username"
              :placeholder="t('username')"
              :rules="[ value => !!value || $t('validations.empty') ]"
              :readonly="loading"
              clearable
              no-error-icon
            />
            <q-input
              dense
              name="password"
              v-model="credentials.password"
              type="password"
              :placeholder="t('password')"
              :readonly="loading"
              clearable
              no-error-icon
            />
            <span
              v-if="invalidCredentials"
              class="text-negative"
              style="font-size: 16px"
            >
              {{ t('invalidCredentials') }}
            </span>
            <div class="q-pt-md">
              <q-btn color="grey-9" outline no-caps style="width: 100%"
                type="submit"
                icon="las la-user"
                :loading="loading"
              >
              <div class="q-px-sm" style="font-weight: 300">{{ t('logIn') }}</div>
              </q-btn>
            </div>
          </q-form>
        </div>
        <div v-else>
          {{ $t('tools.auth.loggedToMapia') }}
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import axios from 'axios'
import { get } from 'lodash'
import { QBtn, QForm, QInput, QPage, QSpinner } from 'quasar'

export default {
  components: {
    QBtn,
    QForm,
    QInput,
    QPage,
    QSpinner
  },
  beforeCreate () {
    this.$store.commit('basicLayout/showAuthBtn', false)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.query.access_token) {
        vm.loading = true
        console.log(vm.$config.oauth.profile)
        axios.get(vm.$config.oauth.profile, { params: { access_token: to.query.access_token } })
          .then(response => {
            vm.$store.commit('auth/setUsername', response.data.username)
            vm.$store.commit('auth/setAccessToken', to.query.access_token)
            vm.loading = false
            vm.$router.replace({ name: 'login', query: { key: vm.accessToken } }).catch(() => {})
          })
          .catch(_ => {
            vm.loading = false
            vm.$router.replace({ name: 'login' }).catch(() => {})
          })
      } else if (to.query.username && to.query.pwd) {
        vm.credentials = {
          username: to.query.username,
          password: to.query.pwd
        }
        vm.credentialsLogin()
      } else {
        vm.$router.replace({ name: 'login' }).catch(() => {})
      }
    })
  },
  data () {
    return {
      credentials: {
        username: this.$store.state.auth.username,
        password: ''
      },
      loading: false,
      canCloseWindow: false,
      loginCodeOk: false,
      loginCodeError: false,
      invalidCredentials: false,
      offset: null
    }
  },
  computed: {
    adminUrl () {
      return get(this.$store.state.auth.profile, 'admin_url')
    },
    isStaff () {
      return get(this.$store.state.auth.profile, 'is_staff')
    },
    oauthType () {
      if (this.$config.oauth && this.$config.oauth.type) {
        return this.$config.oauth.type
      }
      return ''
    },
    labelUser () {
      return this.$store.state.auth.username && this.$store.state.auth.username.slice(0, 2).toUpperCase()
    },
    accessToken () {
      return this.$store.state.auth.accessToken
    }
  },
  mounted () {
    this.invalidCredentials = false
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').catch(this.$except)
    },
    observeAuth () {
      this.$store.dispatch('auth/observeAuth', { seconds: 120 })
    },
    credentialsLogin () {
      this.loading = true
      this.$store.dispatch('auth/credentialsLogin', this.credentials)
        .then(() => {
          this.invalidCredentials = false
          this.credentials.password = ''
          this.loading = false
          this.$router.replace({ name: 'login', query: { key: this.accessToken } }).catch(() => {})
        })
        .then(() => {
          if (this.$config.oauth.userTracking && this.$store.state.auth.username) {
            let headers = this.$store.getters['auth/headers']
            axios.post(this.$config.oauth.userTracking, {}, { headers })
          }
        })
        .catch(({ invalidCredentials }) => {
          if (invalidCredentials) {
            this.invalidCredentials = true
          }
          this.loading = false
          this.$router.replace({ name: 'login' }).catch(() => {})
        })
    },
    t (key) {
      return this.$t('tools.auth.' + key)
    },
    tweakHeight (offset) {
      this.offset = offset ? `calc(100vh - ${offset}px)` : '100vh'
      return this.offset
    }
  }
}
</script>

<style>

</style>
